import { DestroyRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

export const getRequestLandWithRegExForPostalCode = (form: FormGroup, destroyRef: DestroyRef) => {
  return {
    controlForDefaultValue: form.get("land"),
    defaultValue: "DEU",
    controlToSetRegEx: form.get("plz"),
    metadataKey: 'referenz.ansprechpartner.anschrift.plz',
    metadataRegExKey: "common.properties.regExPostalCode",
    destroyRef: destroyRef
  }
};
